"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: "Sélectionner l'heure"
};

exports["default"] = locale;